module.exports = __webpack_public_path__ + "static/media/background-login.96a9ac5b.jpeg";